import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthStateService } from 'src/app/shared/services/auth-state.service';
import { StorageIntegrityService } from 'src/app/shared/services/storage-integrity.service';

@Injectable({ providedIn: 'root' })
export class AuthGuardService implements CanActivate {
  constructor(
    private router: Router,
    private authStateService: AuthStateService,
    private storageIntegrityService: StorageIntegrityService
  ) {}

  async canActivate(): Promise<boolean> {
    // Force-validate integrity on every route change (bypass 10s cache)
    const isValid = await this.storageIntegrityService.validateIntegrity(true);
    if (!isValid) {
      this.storageIntegrityService.handleTampering();
      return false;
    }

    // AuthStateService is the single source of truth (set by APP_INITIALIZER
    // before any route activates). Do NOT fall back to ngx-webstorage here —
    // its in-memory cache is not invalidated by localStorage.clear() on logout,
    // which caused the guard to allow protected routes after logout.
    const isAuthenticated = this.authStateService.isAuthenticated;
    if (!isAuthenticated) {
      this.router.navigate(['/auth/login']);
      return false;
    }

    return true;
  }
}
